<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content width="1100px">
		<kaveh-form :key="ver" :entity="entity" :task="submit" />
	</kaveh-content>
</template>
<script>
	import { BlogContent } from '@/modules/cms/data/blog-content/create'
	import { BlogContentService } from '@/modules/cms/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed: 
		{
			entity()
			{
				return BlogContent
			},
			service()
			{
				return new BlogContentService()
			},
		},
		methods:
		{
			async submit(payload)
			{
				try
				{
					const res = await this.service.create(payload);
					if (res.status == 200)
					{
						this.ver += 1
					}

				} catch (e) { console.log(e) }
			}
		}
	}
</script>